import { Box, Grid } from '@mui/material';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import { CustomTextField } from 'components/common';
import { Control, UseFormRegister } from 'react-hook-form';
import { OnePagerFormFields } from './OnePagerForm';

interface TeamMemberProps {
  control: Control<OnePagerFormFields, object>;
  name: keyof OnePagerFormFields;
  designation: keyof OnePagerFormFields;
  imageUrl?: File;
  inputName: keyof OnePagerFormFields;
  inputId: string;
  handleAllFileInputs: Function;
  ErrorMessage: any;
  errors: any;
  register: UseFormRegister<OnePagerFormFields>;
}

export const TeamMember = ({
  control,
  name,
  designation,
  imageUrl,
  handleAllFileInputs,
  inputId,
  inputName,
  ErrorMessage,
  errors,
  register,
}: TeamMemberProps) => {
  return (
    <Grid item md={6} xs={12} p={2}>
      {/* {imageUrl ? (
        <img src={URL.createObjectURL(imageUrl)} alt="team member image" />
      ) : ( */}
      <>
        <label htmlFor={inputId}>
          <Box
            m="auto"
            height={80}
            width={80}
            sx={{
              backgroundColor: '#F9F9F9',
              borderRadius: 50,
              border: '1px solid #F4F4F4',
            }}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            {imageUrl ? (
              <img
                src={URL.createObjectURL(imageUrl)}
                alt="team member image"
                style={{
                  objectFit: 'contain',
                  width: '80px',
                  height: '80px',
                  borderRadius: '100px',
                }}
              />
            ) : (
              <PhotoCameraIcon sx={{ color: 'rgba(17, 17, 17, 0.3)' }} />
            )}
          </Box>
          {errors[inputName] ? (
            <ErrorMessage text={errors[inputName]['message']} />
          ) : (
            ''
          )}
        </label>
        <input
          {...register(inputName, {
            onChange: (e: any) => {
              handleAllFileInputs(e, 'image', 'Profile');
            },
          })}
          name={inputName}
          id={inputId}
          type="file"
          style={{ display: 'none' }}
        />
        <CustomTextField
          variant="standard"
          control={control}
          name={name}
          defaultValue=""
          placeholder="Name Surname"
          inputProps={{ style: { textAlign: 'center' } }}
          fullWidth
        />
        <CustomTextField
          variant="standard"
          fullWidth
          control={control}
          name={designation}
          defaultValue=""
          inputProps={{ style: { textAlign: 'center' } }}
          placeholder="Designation"
        />
      </>
      {/* )} */}
    </Grid>
  );
};
